import React from 'react';
import './PetAnimations.css';

export default function TurtleSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#4A8C4A';
  const lightColor = color ? lighten(color) : '#6AAC6A';
  const darkColor = color ? darken(color) : '#2A6C2A';
  const shellColor = '#5A7A3A';
  const shellDark = '#3A5A2A';
  const skinColor = '#6AAA5A';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail */}
      <path d="M90 76C96 78 98 76 96 74" stroke={skinColor} strokeWidth="3" strokeLinecap="round" fill="none" />
      {/* Shell (main dome) */}
      <ellipse cx="60" cy="66" rx="32" ry="22" fill={shellColor} />
      {/* Shell top highlight */}
      <ellipse cx="56" cy="58" rx="18" ry="10" fill={lightColor} opacity="0.3" />
      {/* Hexagonal shell pattern */}
      <path d="M48 54L54 50L62 52L66 58L62 64L54 64Z" stroke={shellDark} strokeWidth="1" fill="none" />
      <path d="M62 52L70 50L76 56L74 62L66 58Z" stroke={shellDark} strokeWidth="1" fill="none" />
      <path d="M54 50L56 44L64 44L70 50L62 52Z" stroke={shellDark} strokeWidth="1" fill="none" />
      <path d="M48 54L42 58L44 66L54 64Z" stroke={shellDark} strokeWidth="1" fill="none" />
      <path d="M54 64L52 72L60 74L66 70L62 64Z" stroke={shellDark} strokeWidth="1" fill="none" />
      <path d="M66 58L74 62L72 70L66 70L62 64Z" stroke={shellDark} strokeWidth="1" fill="none" />
      {/* Shell rim */}
      <ellipse cx="60" cy="76" rx="32" ry="8" fill={darkColor} />
      {/* Flippers */}
      <ellipse cx="34" cy="80" rx="10" ry="5" fill={skinColor} transform="rotate(-15 34 80)" />
      <ellipse cx="86" cy="80" rx="10" ry="5" fill={skinColor} transform="rotate(15 86 80)" />
      <ellipse cx="38" cy="90" rx="8" ry="4" fill={skinColor} transform="rotate(-10 38 90)" />
      <ellipse cx="82" cy="90" rx="8" ry="4" fill={skinColor} transform="rotate(10 82 90)" />
      {/* Head */}
      <ellipse cx="36" cy="62" rx="14" ry="12" fill={skinColor} />
      {/* Eyes (calm, half-closed) */}
      <ellipse cx="32" cy="58" rx="3.5" ry="3" fill="white" />
      <ellipse cx="40" cy="58" rx="3.5" ry="3" fill="white" />
      <circle cx="33" cy="58" r="2" fill="#2C4420" />
      <circle cx="41" cy="58" r="2" fill="#2C4420" />
      <circle cx="33.5" cy="57" r="0.8" fill="white" />
      <circle cx="41.5" cy="57" r="0.8" fill="white" />
      {/* Calm eyelids (half-closed look) */}
      <path d="M28 57C30 56 34 56 36 57" stroke={skinColor} strokeWidth="1.5" fill={skinColor} />
      <path d="M36 57C38 56 42 56 44 57" stroke={skinColor} strokeWidth="1.5" fill={skinColor} />
      {/* Nose */}
      <circle cx="30" cy="63" r="1" fill={darkColor} />
      <circle cx="34" cy="63" r="1" fill={darkColor} />
      {/* Mouth */}
      <path d="M28 66C30 68 36 68 38 66" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
